import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';
import type { FC } from 'react';
import Slider from 'react-slick';

import { DEVICE_INSTRUCTIONS } from 'constants/deviceInstructions';

import { SLIDER_SETTINGS, SliderBox } from 'components/SliderWrapper';

import DeviceStepContent from './DeviceStepContent';

const DeviceInstructions: FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      height="100%"
      sx={{ overflowY: 'auto' }}
    >
      <Box mb={2}>
        <Typography variant="h2" textAlign="center" mb={1}>
          {t('common:add_device_info.title')}
        </Typography>
        <Typography mb={2} variant="body1" textAlign="center">
          {t('common:add_device_info.description')}
        </Typography>
      </Box>

      <SliderBox width="100%" px={2}>
        <Slider {...SLIDER_SETTINGS}>
          {DEVICE_INSTRUCTIONS.map(stepData => (
            <Box
              key={stepData.step}
              display="flex"
              justifyContent="center"
              px={2}
            >
              <DeviceStepContent {...stepData} />
            </Box>
          ))}
        </Slider>
      </SliderBox>
    </Box>
  );
};

export default DeviceInstructions;
